import {hitAlgolytics} from "@pg-mono/algolytics";

import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getTrackedOfferData} from "./tracked_utils/tracked_offer";
import {getTrackedPropertyData} from "./tracked_utils/tracked_property";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData} from "./tracked_utils/tracked_vendor";

type QuickViewModalVisibilityTypes = "view" | "close";
type QuickViewModalClickTypes = "right arrow" | "left arrow" | "poi";

export const quickViewModalVisibilityHit = (visibility: QuickViewModalVisibilityTypes, offer: IOfferDetail, property: IPropertyListProperty) => {
    const payload = {
        ...getTrackedSiteData(),
        ...getTrackedVendorData(offer.vendor),
        ...getTrackedOfferData(offer),
        ...getTrackedPropertyData(property)
    };
    hitAlgolytics(`quickview_modal_${visibility}`, payload);
};

export const quickViewModalClickOnElementHit = (element: QuickViewModalClickTypes) => {
    const payload = {
        ...getTrackedSiteData(),
        element
    };

    hitAlgolytics(`quickview_modal_click`, payload);
};

export const quickViewPoiClickOnElement = (category: string) => {
    const payload = {
        element: "poi",
        category,
        ...getTrackedSiteData()
    };

    hitAlgolytics(`quickview_modal_click`, payload);
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IPropertyListProperty} from "../../property/types/PropertyListProperty";
import {getTrackedOfferData} from "./tracked_utils/tracked_offer";
import {getTrackedPropertyData} from "./tracked_utils/tracked_property";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData} from "./tracked_utils/tracked_vendor";

type QuickViewModalVisibilityTypes = "view" | "close";
type QuickViewModalClickTypes = "right arrow" | "left arrow" | "poi";

export const quickViewModalVisibilityHit = (visibility: QuickViewModalVisibilityTypes, offer: IOfferDetail, property: IPropertyListProperty) => {
    const payload = {
        ...getTrackedSiteData(),
        ...getTrackedVendorData(offer.vendor),
        ...getTrackedOfferData(offer),
        ...getTrackedPropertyData(property)
    };
    hitAlgolytics(`quickview_modal_${visibility}`, payload);
};

export const quickViewModalClickOnElementHit = (element: QuickViewModalClickTypes) => {
    const payload = {
        ...getTrackedSiteData(),
        element
    };

    hitAlgolytics(`quickview_modal_click`, payload);
};

export const quickViewPoiClickOnElement = (category: string) => {
    const payload = {
        element: "poi",
        category,
        ...getTrackedSiteData()
    };

    hitAlgolytics(`quickview_modal_click`, payload);
};
